import { render, staticRenderFns } from "./LayerRequests.vue?vue&type=template&id=08f1e0d6"
import script from "./LayerRequests.vue?vue&type=script&lang=js"
export * from "./LayerRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports